import { unstableSetRender } from "antd";
import ReactDOM, { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { GoogleOAuthProvider } from "@react-oauth/google";

unstableSetRender((node, container) => {
  container._reactRoot ||= createRoot(container);
  const root = container._reactRoot;
  root.render(node);
  return async () => {
    await new Promise((resolve) => setTimeout(resolve, 0));
    root.unmount();
  };
});

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root"));
const client_id = process.env.REACT_APP_GOOGLE_CLIENT_ID;
root.render(
  <QueryClientProvider client={queryClient}>
    <GoogleOAuthProvider clientId={client_id}>
      <BrowserRouter basename="/">
        <App />
      </BrowserRouter>
    </GoogleOAuthProvider>
  </QueryClientProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
